import axiosInstance from './axiosInstance';

const FinancialReportDocService = {
  getAll: () => axiosInstance.get('/api/financial-report-docs/'),
  create: (formData) => axiosInstance.post('/api/financial-report-docs/', formData),
  update: (id, formData) => axiosInstance.put(`/api/financial-report-docs/${id}/`, formData),
  delete: (id) => axiosInstance.delete(`/api/financial-report-docs/${id}/`),
};

export default FinancialReportDocService;
